<template>
  <div class="product-card__buttons">

    <div v-if="quantity > 0" class="qty">
      <input class="product-quantity" type="number" v-model="addToCartQuantity" name="quantity" min="1" :max="quantity">
    </div>

    <b-overlay :show="showAddToCartBtnLoadingOverlay"
               rounded
               opacity="0.6"
               spinner-small
               spinner-variant="primary"
               class="d-inline-block">
      <b-button ref="button"
                :disabled="showAddToCartBtnLoadingOverlay"
                variant="primary"
                class="btn btn-primary btn-btn-conversion product-card__addtocart"
                @click="handleAddToCart()">
                <span v-if="!hideIcon" class="mh-icon">
                    <svg width="2em" height="1.4em" viewBox="0 0 16 16" class="bi bi-cart3" fill="currentColor"
                         xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd"
                              d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .49.598l-1 5a.5.5 0 0 1-.465.401l-9.397.472L4.415 11H13a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM3.102 4l.84 4.479 9.144-.459L13.89 4H3.102zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm7 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
                    </svg>
                </span>
        <span class="btn-text">
                {{ text }}
              </span>
      </b-button>
    </b-overlay>
  </div>
</template>


<script type="text/javascript">

import store from '@/common/store'
import {EventBus} from '@/common/utils/event-bus'
import { BOverlay, BButton } from "bootstrap-vue";

export default {
  components: {
    BOverlay,
    BButton
  },
  props: {
    isAllowToOrder: Boolean,
    quantity: Number,
    productId: Number,
    text: {
      type: String,
      default: () => "Do košíku",
      required: false,
    },
    hideIcon: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      addToCartQuantity: 1,
      showAddToCartBtnLoadingOverlay: false,
      addToCartBtnLoadingOverlayIndex: null
    }
  },
  methods: {
    async handleAddToCart() {
      this.showAddToCartBtnLoadingOverlay = true;
      
      if(this.quantity != null && this.quantity > 0 && this.addToCartQuantity > this.quantity){
        return;
      }

      let addToCartResult = await store.dispatch("cartModule/addItemToBasket", {productId: this.productId, quantity: this.addToCartQuantity});
      EventBus.$emit('eshop-cart-item-added', {productId: addToCartResult.productId, quantity: addToCartResult.quantity, name: addToCartResult.productName, brand: addToCartResult.brand, category: addToCartResult.category, price: addToCartResult.productPriceQuantity });

      this.showAddToCartBtnLoadingOverlay = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-text {
  padding-top: 2px;
}

.product-quantity {
  padding: 0.375rem 0.8rem 0.375rem 0.375rem;
}
</style>